module.exports = __webpack_public_path__ + "img/box-skins-golden.4a4df362.jpg";